import { useEffect, useState } from 'react';
import { breakpoints, type Breakpoint } from './breakpoints';

const currentBreakpoint = (): Breakpoint => {
  if (window.matchMedia(`(min-width: ${breakpoints.desktop})`).matches) {
    return 'desktop';
  }
  if (window.matchMedia(`(min-width: ${breakpoints.tablet})`).matches) {
    return 'tablet';
  }

  return 'mobile';
};

export const useMediaQuery = (): Breakpoint => {
  const [breakpoint, setBreakpoint] = useState(currentBreakpoint);

  useEffect(() => {
    const mediaQueryLists = [breakpoints.tablet, breakpoints.desktop].map(
      (bp) => window.matchMedia(`(min-width: ${bp})`),
    );
    const onChange = () => setBreakpoint(currentBreakpoint());
    mediaQueryLists.forEach((mql) => mql.addEventListener('change', onChange));

    return () =>
      mediaQueryLists.forEach((mql) =>
        mql.removeEventListener('change', onChange),
      );
  }, []);

  return breakpoint;
};
